import React, { useState } from 'react';
import LocalModal from '../base/local-modal';
import { Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import useDashboardContext from 'contexts/dashboard.context';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { handleApiError } from 'utils/functions';
import { DepartmentType } from 'models/department.model';
const AddDepartment = ({
  show,
  onClose,
  setDepartmentList,
  departmentList
}: {
  show: boolean;
  onClose: () => void;
  setDepartmentList: (dpts: DepartmentType[]) => void;
  departmentList: DepartmentType[];
}) => {
  const { activeCompany } = useDashboardContext();
  const newDept = { name: '' };
  const [department, setDepartment] = useState([newDept]);
  const companyId = activeCompany?.id;

  const addNewDepartment = () => {
    setDepartment([...department, newDept]);
  };
  const handleChange = (e: any, i: number) => {
    const { value }: { name: any; value: any } = e.target;
    const arr: any = [...department];

    arr[i].name = value;

    setDepartment([...arr]);
  };
  const addDepartment = async () => {
    if (!companyId) return;
    const filteredData = department?.filter((item) => item.name !== '');
    const data = filteredData.map((item) => {
      return {
        name: item.name,
        company_id: companyId
      };
    });
    try {
      const res = await apiService.post(`department/add/multiple`, { data });
      if (res) {
        setDepartmentList([...departmentList, ...res.data.data]);
        toast(<ToastMessage type='success' message='Department added successfully' />);
        onClose();
      }
    } catch (err) {
      handleApiError(err);
    }
  };
  return (
    <div>
      <LocalModal
        isOpen={show}
        title='Add department'
        description={``}
        onRequestClose={() => onClose()}
        footer={
          <div className='flex gap-5 justify-end '>
            <Button
              onClick={onClose}
              className='w-[139px] h-[41px] !bg-[#F2F2F2] !border-[#F2F2F2] !text-[#2E3031] text-sm'
              color='gray'
              small
              variant='block'>
              Cancel
            </Button>
            <Button
              className='w-[139px] h-[41px] text-sm'
              color='primary'
              small
              variant='block'
              onClick={addDepartment}>
              Confirm
            </Button>
          </div>
        }>
        <div>
          {department?.map((item, index) => (
            <div key={index}>
              <Input
                design='bordered'
                className='mb-5'
                type='text'
                value={item.name}
                label='Department name'
                placeholder='e.g Accounting'
                onChange={(e) => handleChange(e, index)}
                subAction={
                  index >= 1 && (
                    <button
                      className=' text-[#E60A2B] text-[13px] font-[500]'
                      onClick={() =>
                        setDepartment((prev: any) =>
                          prev.filter((obj: any, i: number) => i !== index)
                        )
                      }>
                      - Remove department
                    </button>
                  )
                }
              />
            </div>
          ))}

          <button onClick={addNewDepartment} className='text-[#0080E5]'>
            + Add department
          </button>
        </div>
      </LocalModal>
    </div>
  );
};

export default AddDepartment;
